/* eslint-disable import/no-anonymous-default-export */
export default [
    {
        projectName:'TEk Store',
        porjectPicture:'https://i.im.ge/2022/09/23/1hna7y.tek.png',
        projectURL:'https://tekstore.pages.dev/',
        title: 'live demo'
    },
    {
        projectName:'HooBank',
        porjectPicture:'https://i.im.ge/2022/09/23/1hno7r.hooBank-site.png',
        projectURL:'https://hoo-bank-1dm.pages.dev/',
        title: 'live demo'
    },
    {
        projectName:'Hotel Room Booking',
        porjectPicture:'https://i.im.ge/2022/09/23/1hnSix.room-boking.png',
        projectURL:'https://hotelbooking.pages.dev/',
        title: 'live demo'
    },
    {
        projectName:'NETFLIX Clone',
        porjectPicture:'https://i.im.ge/2022/09/23/1hn2XG.netflix-clone.png',
        projectURL:'https://netflixclone-a9w.pages.dev/',
        title: 'live demo'
    },
    
    {
        projectName:'Gym Website',
        porjectPicture:'https://i.im.ge/2022/09/23/1hnlp0.gym-site.png',
        projectURL:'https://gymwebsite-91b.pages.dev/',
        title: 'live demo'
    },
    {
        projectName:'Redux Store',
        porjectPicture:'https://i.im.ge/2022/09/23/1hnOKL.redux-store-site.png',
        projectURL:'https://redux-store.pages.dev/',
        title: 'live demo'
    },
    {
        projectName:'Pyramids',
        porjectPicture:'https://i.im.ge/2022/09/23/1hnXAW.pyramids-site.png',
        projectURL:'https://pyramid-22f.pages.dev',
        title: 'live demo'
    },
    {
        projectName:'BoStep',
        porjectPicture:'https://i.im.ge/2022/09/24/15cMJP.bostep-site.png',
        projectURL:'https://bostep.netlify.app/',
        title: 'live demo'
    },
    {
        projectName:'Meme Generator',
        porjectPicture:'https://i.im.ge/2022/09/23/1hnMbf.meme-generator.png',
        projectURL:'https://memegenerator.pages.dev/',
        title: 'live demo'
    },
    {
        projectName:'Speed Typing Counter',
        porjectPicture:'https://i.im.ge/2022/09/23/1hnFwc.speed-site.png',
        projectURL:'https://speedtypingcounter.pages.dev/',
        title: 'live demo'
    },
    {
        projectName:'Password Generator Extension',
        porjectPicture:'https://i.im.ge/2022/09/23/1hnQGm.password-generetor.png',
        projectURL:'https://github.com/Akhalil123321/Password-Generator-Chrome-Extension',
        title: 'github'
    },
    {
        projectName:'URL Depository Extintion',
        porjectPicture:'https://i.im.ge/2022/09/23/1hnDpz.url-extention.png',
        projectURL:'https://github.com/Akhalil123321/URL-Depository-Chrome-Extintion',
        title: 'github'
    },
    {
        projectName:'APIs MiniProjects',
        porjectPicture:'https://i.im.ge/2022/09/23/1hnu2T.Api-projects.png',
        projectURL:'https://github.com/Akhalil123321/APIs-MiniProjects',
        title: 'github'
    },
    {
        projectName:'Tailwind Projects',
        porjectPicture:'https://i.im.ge/2022/09/23/1hn7CS.Tailwind-Projects.png',
        projectURL:'https://github.com/Akhalil123321/Tailwind-Projects',
        title: 'github'
    },
    
]
